module.exports = __webpack_public_path__ + "img/2016-1.ecec04f3.jpg";